module.exports = __webpack_public_path__ + "img/home-delivery-date-top-img_small.c00af7df.webp";